<template>
    <div class="header-box">
        <div class="header">
            <p>Hola. ¡Bienvenido/a a Transfelicia!</p>
            <div class="logout" v-if="online">
                <img
                    class="img-left"
                    src="@/assets/image/icon-personal.webp"
                    alt=""
                />
                <span>{{ userName }}</span>
                <img
                    src="@/assets/image/icon-out.webp"
                    alt=""
                    class="img-right"
                    @click="logoutVisible = true"
                />
            </div>
            <div class="header-btn" @click="loginVisible = true" v-else>
                Iniciar sesión/Registrarse
            </div>
        </div>
        <Modal
            v-model="loginVisible"
            :footer-hide="true"
            width="1000"
            :closable="false"
            class-name="vertical-center-modal"
        >
            <Login></Login>
        </Modal>
        <Modal
            v-model="logoutVisible"
            :footer-hide="true"
            width="1000"
            :closable="false"
            class-name="vertical-center-modal"
        >
            <div class="logout-box">
                <div class="logout-title">
                    ¿Seguro que quieres cerrar sesión?
                </div>
                <div class="logout-btns">
                    <div class="logout-btn" @click="logoutVisible = false">
                        Cancelar
                    </div>
                    <div class="logout-btn logout-ok" @click="toLogout">
                        Confirmar
                    </div>
                </div>
            </div>
        </Modal>
    </div>
</template>
<script>
import Login from "./login.vue";
import { mapState } from "vuex";
export default {
    components: {
        Login,
    },
    data() {
        return {
            loginVisible: false,
            logoutVisible: false,
            orderData: {},
        };
    },
    computed: {
        ...mapState(["online", "userName"]),
    },
    methods: {
        toLogout() {
            sessionStorage.clear();
            location.reload();
        },
    },
};
</script>
<style lang="less" scoped>
.header-box {
    width: 100%;
    height: 40px;
    background: #f7f7f7;
}
.header {
    width: 1188px;
    height: 40px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.header p {
    font-weight: 400;
    font-size: 12px;
    color: #666666;
}
.header-btn {
    height: 24px;
    background: #333333;
    border-radius: 4px;
    color: #ffffff;
    padding: 0 8px;
    font-weight: 400;
    font-size: 12px;
    line-height: 24px;
    cursor: pointer;
}
/deep/ .ivu-modal-body {
    padding: 0;
}
/deep/ .ivu-modal-content {
    border-radius: 16px;
}
.logout {
    // width: 127px;
    height: 24px;
    display: flex;
    align-items: center;
    .img-left {
        width: 21px;
        height: 21px;
    }
    .img-right {
        width: 16px;
        height: 16px;
        cursor: pointer;
    }
    span {
        padding: 0 5px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 600;
        font-size: 12px;
        color: #333333;
    }
}
.logout-box {
    height: 266px;
    background: linear-gradient(180deg, #fef1b6 0%, #ffffff 37%, #ffffff 100%);
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .logout-title {
        font-family: PingFang SC, PingFang SC;
        font-weight: 600;
        font-size: 26px;
        color: #000000;
    }
    .logout-btns {
        display: flex;
        margin-top: 40px;
        .logout-btn {
            width: 376px;
            height: 60px;
            background: #cccccc;
            border-radius: 8px;
            font-family: PingFang SC, PingFang SC;
            font-weight: 600;
            font-size: 20px;
            color: #666666;
            line-height: 60px;
            text-align: center;
            cursor: pointer;
        }
        .logout-ok {
            background: #ffe955;
            color: #000000;
            margin-left: 20px;
        }
    }
}
/deep/ .vertical-center-modal {
    display: flex;
    align-items: center;
    justify-content: center;

    .ivu-modal {
        top: 0;
    }
}
</style>